"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedRoute = ProtectedRoute;
exports.PublicRoute = PublicRoute;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var use_permissions_1 = require("../../hooks/use-permissions");
/**
 * Protected route component that checks authentication and permissions.
 * Redirects to login if not authenticated, or to dashboard if no permission.
 */
function ProtectedRoute(props) {
    var requiredModule = props.requiredModule, _a = props.redirectTo, redirectTo = _a === void 0 ? "/login" : _a;
    var location = (0, react_router_dom_1.useLocation)();
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.auth; }), isAuthenticated = _b.isAuthenticated, isLoading = _b.isLoading;
    var canAccess = (0, use_permissions_1.usePermissions)().canAccess;
    // Show nothing while checking auth state
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex h-screen w-full items-center justify-center", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-4", children: [(0, jsx_runtime_1.jsx)("div", { className: "h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" }), (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: "Loading..." })] }) }));
    }
    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: redirectTo, state: { from: location }, replace: true });
    }
    // Check module permission if specified
    if (requiredModule && !canAccess(requiredModule)) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/dashboard", replace: true });
    }
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {});
}
/**
 * Public route component for pages like login.
 * If restricted is true, authenticated users will be redirected to dashboard.
 */
function PublicRoute(props) {
    var _a = props.restricted, restricted = _a === void 0 ? false : _a;
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.auth; }), isAuthenticated = _b.isAuthenticated, isLoading = _b.isLoading;
    // Show nothing while checking auth state
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex h-screen w-full items-center justify-center", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-4", children: [(0, jsx_runtime_1.jsx)("div", { className: "h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" }), (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: "Loading..." })] }) }));
    }
    // Redirect to dashboard if authenticated and route is restricted
    if (restricted && isAuthenticated) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/dashboard", replace: true });
    }
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {});
}
